import { getNewsletterHistoryStatusMeta } from "./newsletterHistoryStatusUtils";
import { formatDate } from "../../../../utils/formatters";

export const buildPublishSuccessMessage = (result, scheduleMode) => {
  const statusMeta = getNewsletterHistoryStatusMeta(result.status);
  if (result.status === "scheduled" || scheduleMode === "scheduled") {
    const when = result.scheduledAt ? formatDate(result.scheduledAt) : "data programmata";
    return {
      title: "Invio programmato",
      message: `Newsletter programmata per ${when} (${result.recipientCount} destinatari). Stato: ${statusMeta.label}.`,
    };
  }
  if (result.errorCount > 0) {
    return {
      title: "Invio completato con errori",
      message: `Newsletter inviata a ${result.recipientCount} destinatari con ${result.errorCount} errori. Stato: ${statusMeta.label}.`,
    };
  }
  return {
    title: "Invio completato",
    message: `Newsletter inviata a ${result.recipientCount} destinatari. Stato: ${statusMeta.label}.`,
  };
};
